import { createApiRef } from '@backstage/core-plugin-api';
import { DefaultApiClient } from '@internal/plugin-helmreleases-common';

export const helmReleasesApiRef = createApiRef<DefaultApiClient>({
  id: 'plugin.helmreleases.service',
});
